import { ProgressSpinner } from 'primereact/progressspinner'
import { useTranslation } from 'react-i18next'

/**
 * Kimlik (persona) değişirken kabuk yerine gösterilen nötr yükleme.
 *
 * <p><b>Neden ortak bileşen:</b> aynı dört satır iki yerde birebir duruyordu — {@code AppLayout}'un
 * persona geçişinde ve {@code AssistantPersonaBootstrap}'in açılış geçişinde. İkisi aynı işi anlatıyor
 * ve aynı metni (`proxy.switching`) kullanıyor; iki kopyada biri güncellenip diğeri unutulurdu.
 *
 * <p>Metin bilinçle `proxy.switching` ("Kimlik değiştiriliyor…"), `auth.loading` DEĞİL: burada yapılan
 * kimlik <b>değişimi</b>dir, oturum doğrulaması değil.
 *
 * <p>{@code <output>} kullanılır, {@code role="status"} taşıyan bir {@code div} değil: ikisi de aynı
 * erişilebilirlik rolünü verir ({@code output}'un örtük rolü {@code status}'tür, mevcut testler
 * {@code getByRole('status')} ile çalışmaya devam eder) ama {@code output} tüm cihazlarda destekleniyor
 * (Sonar S6819). Varsayılan {@code display: inline} sınıftaki {@code flex} ile eziliyor.
 */
export default function ProxySwitchingNotice() {
  const { t } = useTranslation()
  return (
    <output className="app-content-switching" aria-live="polite">
      <ProgressSpinner strokeWidth="4" style={{ width: 40, height: 40 }} />
      <p>{t('proxy.switching')}</p>
    </output>
  )
}
